var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5L7.5 0H1.75C0.783502 0 0 0.783502 0 1.75V13.25C0 14.2165 0.783502 15 1.75 15H10.75C11.7165 15 12.5 14.2165 12.5 13.25V5ZM7.49817 6.25595H7.49763V6.25195H2.50391V6.25595V6.6681V7.48604V7.90218V9.15942V9.57557V10.833V11.2492V11.2497H2.92005V11.2492H4.17578V11.2497H4.59192V11.2492H5.41406V11.2497H5.83021V11.2492H7.08203V11.2497H7.49817V6.25595ZM2.92005 7.48604V6.6681H7.08203V7.48604H2.92005ZM5.83021 7.90218H7.08203V9.15942H5.83021V7.90218ZM5.83021 9.57557H7.08203V10.833H5.83021V9.57557ZM5.41406 9.57557V10.833H4.59192V9.57557H5.41406ZM4.17578 9.57557V10.833H2.92005V9.57557H4.17578ZM4.17578 9.15942H2.92005V7.90218H4.17578V9.15942ZM4.59192 9.15942V7.90218H5.41406V9.15942H4.59192Z",
    fill: "#1ABF74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.8e529d6552c39ba2fc4078998ab744b5.svg";
export { ForwardRef as ReactComponent };